import router from "@/router.js"

//
import { setOrderDetailProductList } from "@/storage/orderDetail.js"

function payApiCommitOrder(shopId, productList, ifShoppingCar)
{
    //
    setOrderDetailProductList(shopId, productList);

    //
    router.push({
        path: `orderDetail?ifShoppingCar=${ifShoppingCar}&shopId=${shopId}`,
    })
}

export default {
    payApiCommitOrder,
}